function KeputusanPenerimaan({ dataSantri }) {
    return (
        <>
            <div style={{
                textAlign: "center",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <table style={{ width: "50%", border: '1px solid #000' }}>
                    <tr>
                        <td style={{ width: "25%" }}><h3>{(dataSantri.isLulus) ? "DITERIMA" : "TIDAK DITERIMA"}</h3></td>
                        <td style={{ width: "25%", backgroundColor: (dataSantri.isLulus) ? "greenyellow" : "red" }}></td>
                    </tr>
                </table>
            </div>
        </>
    )
}

export default KeputusanPenerimaan;